import  { useState, useEffect } from "react";
import useAdBlockStore from "store/AdBlockStore";
import {
  OfferPriceEachTextBuilder,
  OfferBOGOTextBuilder,
  OfferSaveTextBuilder,
  OfferUpTextBuilder,
  OfferXForTextBuilder,
  OfferPurchaseTextBuilder,
  OfferFreeWithTextBuilder,
  OfferPurchaseQtyTextBuilder,
  OfferPurchaseQtyValTextBuilder,
  OfferPurchaseCaseTextBuilder,
  OfferPurchaseProductTextBuilder,
  OfferAgreementTextBuilder,
  OfferRecipeTextBuilder,
  OfferOtherTextBuilder,
  OfferRewardsCouponsTextBuilder,
} from "components";


export const OfferTextBuilder = ({ onStartChange = () => { }, view = "offer" }) => {
  const offers = useAdBlockStore((state) => state.offers);
  const currentOffer = useAdBlockStore((state) => state.currentOffer);
  const updateCurrentOffer = useAdBlockStore((state) => state.updateCurrentOffer);
  // const [useDefaultSaveOfferText, setUseDefaultSaveOfferText] = useState(true);
  const [firstDefaultSaveOfferText, setFirstDefaultSaveOfferText] = useState('');
  const type = currentOffer?.offer_type || '';
  const value = currentOffer?.offer_text || '';

  const onChange = (e) => {
    updateCurrentOffer({
      offer_text: e,
      qty_off_total_purchase_f: e.match(' each') ? false : true
    })
  };

  // Ticket: AD-588
  useEffect(() => {
      let firstOffer = [];
      if (offers){
        firstOffer = offers?.filter(item => 
          item?.offer_type.toLowerCase() === 'price ea' || item?.offer_type.toLowerCase() === 'bogo'  ||
          item?.offer_type.toLowerCase() === '& up' || item?.offer_type.toLowerCase() === 'x for' ||
          item?.offer_type.toLowerCase() === 'w/purchase/$' || item?.offer_type.toLowerCase() === 'w/purchase/qty' ||
          item?.offer_type.toLowerCase() === 'w/purchase/qty/$')
      }
      // setUseDefaultSaveOfferText(false ? firstOffer.length > 0 : true);
      if (firstOffer.length > 0) {
        // setUseDefaultSaveOfferText(false);
        let maxVal = 0;
        if (offers && !currentOffer?.offer_text) {
          let findPriceEa = offers.find(item => item.offer_type.toLowerCase() === "price ea");
          console.log('findPriceEa', findPriceEa)
          let findOffers = '';
          if (findPriceEa) {
            findPriceEa = findPriceEa.offer_text;
            let val = findPriceEa.split("-")
            // eslint-disable-next-line
            let numbers = val.map(item => item.replace(/[^\d\.]*/g, ''));
            maxVal = Math.max(...numbers)
          } else {
            findOffers = offers.filter(item => item.offer_type.toLowerCase() !== "save")[0];
            if (findOffers) {
              if (findOffers.offer_type.toLowerCase() === 'bogo') {
  
              } else if (findOffers.offer_type.toLowerCase() === '& up') {
                maxVal = findOffers.offer_text.substring(1).split(' ')[0];
              } else if (findOffers.offer_type.toLowerCase() === 'x for') {
                maxVal = findOffers.offer_text.split('$')[1];
              } else if (findOffers.offer_type.toLowerCase() === 'w/purchase/$') {
                const reg = /w\/purchase\/\$(\d+(?:\.\d+)?)(?:-(\d+(?:\.\d+)?))?/;
                const match = findOffers.offer_text.match(reg);
                if (match) {
                  const first = match[1];
                  const second = match[2];
                  if (first) {
                    if (second) {
                      maxVal = Math.max(first, second);
                    } else {
                      maxVal = first;
                    }
                  }
                }
              } else if (findOffers.offer_type.toLowerCase() === 'w/purchase/qty') {
                const reg = /w\/purchase\/(\d+(?:\.\d+)?)(?:-(\d+(?:\.\d+)?))?/;
                const match = findOffers.offer_text.match(reg);
                if (match) {
                  const first = match[1];
                  const second = match[2];
                  if (first) {
                    if (second) {
                      maxVal = Math.max(first, second);
                    } else {
                      maxVal = first;
                    }
                  }
                }
              } else if (findOffers.offer_type.toLowerCase() === 'w/purchase/qty/$') {
                maxVal = findOffers.offer_text.split('$')[1];
              }
            }
          }
        }
        if (maxVal) {
          setFirstDefaultSaveOfferText(maxVal);
        }
      } 
      // else {
      //   setUseDefaultSaveOfferText(true);
      // }
      return () => {};
    }, [offers])

  return (
    <>
      <h6 className="p-1" style={{ color: '#66c0e1' }}>Offer Text Builder</h6>

      {type.toLowerCase() === "price ea" && (
        <OfferPriceEachTextBuilder
          value={type.toLowerCase() === "price ea" ? value : "1.00"}
          onChange={onChange}
        />
      )}
      {type === "BOGO" && (
        <OfferBOGOTextBuilder
          value={type === "BOGO" ? value : "B1G1F"}
          onChange={onChange}
        />
      )}

      {(type === "Save" || type === 'save') && (
        <OfferSaveTextBuilder
          value={(type === "save" || type === 'Save') ? value : "save 10%"}
          onChange={onChange}
          onStartChange={onStartChange}
          existingOfferText={firstDefaultSaveOfferText}
          view={view}
        />
      )}

      {type === "& Up" && (
        <OfferUpTextBuilder
          value={type === "& Up" ? value : "$5 & Up"}
          onChange={onChange}
        />
      )}
      {type === "X For" && (
        <OfferXForTextBuilder
          value={type === "X For" ? value : "2/$2"}
          onChange={onChange}
        />
      )}
      {type === "w/purchase/$" && (
        <OfferPurchaseTextBuilder
          value={type === "w/purchase/$" ? value : "w/purchase/$10.00"}
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "w/purchase/qty" && (
        <OfferPurchaseQtyTextBuilder
          value={
            type.toLowerCase() === "w/purchase/qty" ? value : "w/purchase/2"
          }
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "w/purchase/qty/$" && (
        <OfferPurchaseQtyValTextBuilder
          value={
            type.toLowerCase() === "w/purchase/qty/$"
              ? value
              : "w/purchase/2/$10"
          }
          onChange={onChange}
        />
      )}
      {type === "w/purchase case" && (
        <OfferPurchaseCaseTextBuilder
          value={type === "w/purchase case" ? value : ""}
          onChange={onChange}
        />
      )}
      {type === "w/purchase product" && (
        <OfferPurchaseProductTextBuilder
          value={type === "w/purchase product" ? value : ""}
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "w/agreement" && (
        <OfferAgreementTextBuilder
          value={type.toLowerCase() === "w/agreement" ? value : "Qualified Upgrade"}
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "free with" && (
        <OfferFreeWithTextBuilder
          value={type.toLowerCase() === "free with" ? value : ""}
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "recipe" && (
        <OfferRecipeTextBuilder
          value={type.toLowerCase() === "recipe" ? value : "per serving"}
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "other" && (
        <OfferOtherTextBuilder
          value={type.toLowerCase() === "other" ? value : "w/purchase/"}
          onChange={onChange}
        />
      )}
      {type.toLowerCase() === "w/rewards and coupons" && (
        <OfferRewardsCouponsTextBuilder
          value={type.toLowerCase() === "w/rewards and coupons" ? value : "w/coupon"}
          onChange={onChange}
        />
      )}
    </>
  );
};
